import { ReactElement } from 'react';

import successImage from 'modules/common/assets/stake-success.png';
import { SuccessDialogContent } from 'modules/common/components/SuccessDialogContent';
import { useTranslation } from 'modules/i18n';

import { translation } from './translation';

interface IClaimSuccessContentProps {
  onClose: () => void;
}

export function ClaimSuccessContent({
  onClose,
}: IClaimSuccessContentProps): ReactElement {
  const { t, keys } = useTranslation(translation);

  return (
    <SuccessDialogContent
      buttonLabel={t(keys.buttonText)}
      description={t(keys.doneDescription)}
      image={successImage}
      title={t(keys.done)}
      onClose={onClose}
    />
  );
}
